import { render, staticRenderFns } from "./minimal.vue?vue&type=template&id=208ccf6a&scoped=true"
import script from "./minimal.vue?vue&type=script&lang=js"
export * from "./minimal.vue?vue&type=script&lang=js"
import style0 from "./minimal.vue?vue&type=style&index=0&id=208ccf6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208ccf6a",
  null
  
)

export default component.exports